<template>
  <!--<div id="maphome">-->
  <!--<div id="headText">Osmbuildings</div>-->
  <!--<div id="mapcontent">-->
  <div id="myMap"></div>
  <!--</div>-->
  <!--</div>-->
</template>

<script>
  export default {
    name: 'mapGaode',
    data() {
      return {

      }
    },
    computed: {},
    mounted() {
      this.initLeaflet();
    },
    watch: {},
    methods: {
      initLeaflet() {
        var mymap = L.map('myMap', {
          center: [40.7573046875, -73.9599609375],
          zoom: 11,
          fullscreenControl: {
            pseudoFullscreen: true
          }
        });
        L.tileLayer(
          'http://localhost:8080/geoserver/gwc/service/wmts?layer=tiger%3Apoly_landmarks&style&tilematrixset=EPSG%3A4326&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fpng&TileMatrix=EPSG%3A4326%3A{z}&TileCol={x}&TileRow={y}', {
            attribution: '铿锵侠 &copy; 谷歌地图',
            maxZoom: 18,
            minZoom: 9,
            subdomains: "123"
          }).addTo(mymap);

      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #maphome {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url(../../../static/background.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow-y: hidden;
  }

  #headText {
    color: white;
    margin: 50px;
    font-size: 20px;
  }

  #mapcontent {
    display: flex;
    justify-content: center;
  }

  #home-cartoon {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }

  #myMap {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

</style>



// WEBPACK FOOTER //
// mapOsmbuildings.vue?3a324732